import React from 'react';
import lodash from 'lodash';
import ObjectUtils from '../../../../../modules/ObjectUtils';
import UtilitiesService from '../../../../../service/UtilitiesService';
import JacksonDetailedAccountModal from './JacksonDetailedAccountModal';
import JacksonDetailedBillModal from './JacksonDetailedBillModal';
import Grid from '../../../../grid/Grid';
import FieldSet from '../../../../fieldset/FieldSet';
import SearchBar from '../../../../searchbar/SearchBar';
import AsyncActionButton from '../../../../button/AsyncActionButton';
import AccountLinkForm from '../../../../form/AccountLinkForm';

class Jackson extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accountHeaders: [],
      accountRows: [],
    };
    this.comboFields = [
      {
        value: 'externalAccountId',
        display: 'External Account ID',
      },
      {
        value: 'customerId',
        display: 'Customer ID',
      },
    ];
  }

  SERVICE_OFFERING_ID = 'jackson_property_tax';

  onAccountRowSelect(selectedRow) {
    const { accountRows, selectedAccount, } = this.state;
    if (selectedAccount && selectedAccount.id === selectedRow.id) {
      return;
    }
    this.resetBills();
    const foundAccount = accountRows.find((account) => {
      const { raw, } = account;
      return raw.id === selectedRow.id;
    });

    this.setState({
      selectedAccount: foundAccount.raw,
    });
  }

  onBillRowSelect(selectedRow) {
    const { billRows, } = this.state;
    const selectedBill = billRows.find((bill) => {
      const { raw, } = bill;
      return raw.id === selectedRow.id;
    });
    this.setState({
      selectedBill: selectedBill.raw,
    });
  }

  onClick(event) {
    this.reset();
    const { combo, search, } = event;
    const criteria = {};
    const headers = [];
    const rows = [];
    criteria[combo.value] = search.value;
    criteria.serviceOfferingId = this.SERVICE_OFFERING_ID;

    UtilitiesService.getUtilityAccountBySearch(criteria)
      .then((response) => {
        const { accounts, } = response.data;
        const exclusions = value => [
          'id',
          'externalAccountId',
          'streetName',
          'streetNumber',
          'city',
          'zip',
          'ownerFirstName',
          'ownerLastName',
        ].includes(value);

        if (accounts && accounts.length > 0) {
          const proto = accounts[0];
          const filteredProto = ObjectUtils.filterObject(proto, exclusions);
          Object.keys(filteredProto.value).forEach((key) => {
            headers.push({
              value: key,
              display: lodash.startCase(key),
            });
          });
          accounts.forEach((account) => {
            const copyAccount = { ...account, };
            copyAccount.customerIds = ObjectUtils.formatStringAsJSONArray(copyAccount.customerIds);
            const filteredAccount = ObjectUtils.filterObject(copyAccount, exclusions);
            rows.push({
              value: Object.values(filteredAccount.value),
              raw: filteredAccount.raw,
            });
          });
        }

        this.setState({
          accountHeaders: headers,
          accountRows: rows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  onBillClick(accountId) {
    this.resetBills();
    const headers = [];
    const rows = [];
    const criteria = {};
    criteria.accountId = accountId;
    criteria.serviceOfferingId = this.SERVICE_OFFERING_ID;
    this.setState({
      isBillLoading: true,
    });

    UtilitiesService.getUtilityBillBySearch(criteria)
      .then((response) => {
        const { bills, } = response.data;
        const exclusions = value => [
          'id',
          'taxYear',
          'clientBillBalance',
          'payItBillBalance',
          'paid',
          'externalBillId',
        ].includes(value);
        if (bills && bills.length > 0) {
          const proto = bills[0];
          const filtredProto = ObjectUtils.filterObject(proto, exclusions);
          Object.keys(filtredProto.value).forEach((key) => {
            headers.push({
              value: key,
              display: lodash.startCase(key),
            });
          });
          bills.forEach((bill) => {
            const protoBill = ObjectUtils.filterObject(bill, exclusions);
            rows.push({
              value: Object.values(protoBill.value),
              raw: protoBill.raw,
            });
          });
        }

        this.setState({
          billHeaders: headers,
          billRows: rows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.setState({ isBillLoading: false, });
      });
  }

  showSelectedAccountDetails(selectedAccount) {
    const { isBillLoading, } = this.state;
    if (!selectedAccount) {
      return null;
    }

    return (
      <div className="container">
        <p>{`Selected ID: ${selectedAccount.id}`}</p>
        <hr />
        <div className="row">
          <div className="m-1">
            <JacksonDetailedAccountModal account={selectedAccount} />
          </div>
          <div className="m-1">
            <AsyncActionButton
              onClick={() => this.onBillClick(selectedAccount.id)}
              contents="Show Bills"
              isLoading={isBillLoading}
              variant="primary"
              loadingVariant="secondary"
            />
          </div>
          <div className="m-1">
            <AccountLinkForm
              title="Link/Unlink Customers"
              id={selectedAccount.id}
              customerIds={selectedAccount.customerIds}
              serviceOfferingId={this.SERVICE_OFFERING_ID}
            />
          </div>
        </div>
      </div>
    );
  }

  showSelectedBillDetails(selectedBill) {
    if (!selectedBill) {
      return null;
    }

    return (
      <div className="container">
        <p>{`Selected ID: ${selectedBill.id}`}</p>
        <hr />
        <div className="row">
          <JacksonDetailedBillModal bill={selectedBill} />
        </div>
      </div>
    );
  }

  reset() {
    this.setState({
      accountHeaders: [],
      accountRows: [],
      billHeaders: [],
      billRows: [],
      selectedAccount: null,
      selectedBill: null,
    });
  }

  resetBills() {
    this.setState({
      billHeaders: [],
      billRows: [],
      selectedBill: null,
    });
  }

  render() {
    const {
      accountHeaders = [],
      accountRows = [],
      billHeaders = [],
      billRows = [],
      selectedAccount,
      selectedBill,
    } = this.state;

    return (
      <div className="container">
        <SearchBar comboFields={this.comboFields} onClick={data => this.onClick(data)} />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Property Accounts" style={{ maxHeight: '300px', }}>
            <Grid
              headers={accountHeaders}
              rows={accountRows}
              onRowSelect={row => this.onAccountRowSelect(row)}
            />
          </FieldSet>
          {this.showSelectedAccountDetails(selectedAccount)}
        </div>
        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Property Bill" style={{ maxHeight: '300px', }}>
            <Grid
              headers={billHeaders}
              rows={billRows}
              onRowSelect={row => this.onBillRowSelect(row)}
            />
          </FieldSet>
          {this.showSelectedBillDetails(selectedBill)}
        </div>
      </div>
    );
  }
}

export default Jackson;
